import { RootState } from "./store";
import { NETWORK_TYPE, NetworkType } from "utils/network";

export const cardNumberSelector = (state: RootState) =>
  state.user.userCardNumber;
export const userProfileSelector = (state: RootState) => state.user.userProfile;
export const authUidSelector = (state: RootState) => state.user.authUid;
export const networkSelector = (state: RootState) => state.user.network;

/**
 * The network to send to the API. Returns a plain string, so components can
 * subscribe to it without a memoised selector.
 */
export const networkTypeSelector = (state: RootState): NetworkType =>
  state.user.network?.value ?? NETWORK_TYPE;
export const cardInfoSelector = (state: RootState) => state.user.cardInfo;
export const cardBalanceSelector = (state: RootState) => state.user.cardBalance;
export const cardTransactionsSelector = (state: RootState) =>
  state.user.cardTransactions;
export const userTypeSelector = (state: RootState) => state.user.userType;
export const showLoadMoreSelector = (state: RootState) =>
  state.user.showLoadMore;
export const merchantNameByAddressSelector =
  (address: string) => (state: RootState) =>
    state.user.merchantsMap[address];
export const merchantNameByAddressMapSelector = (state: RootState) =>
  state.user.merchantsMap;

/** Raw preference — read via useSettlementToken, which validates it against the live list. */
export const settlementTokenAddressSelector = (state: RootState) =>
  state.user.settlementTokenAddress;
